import React from "react";
import { string, object } from "prop-types";
import { Link, SocialShare } from "@quintype/components";
import get from "lodash/get";
import { connect } from "react-redux";

import CardImage from "../../atoms/CardImage";
import Headline from "../../atoms/Headline";
import SocialShareTemplate from "../../molecules/SocialShareTemplate";
import StoryMetaData from "../../molecules/StoryMetaData";
import CustomStoryCard5 from "../../molecules/CustomStoryCard5";
import DfpAd from "../../dfp-ad";

import "./bigVideoStoryCard2Ad.m.css";

const BigVideoStoryCard2Ad = ({ collection, publisherAttributes }) => {
  const stories = collection.items.filter((item) => item.type === "story" && item.story).map(({ story }) => story);
  if (!stories.length) {
    return null;
  }

  const adSlotId1 = get(collection, ["associated-metadata", "ad_slot_id1"], "default_ad_slot1");
  const adSlotId2 = get(collection, ["associated-metadata", "ad_slot_id2"], "default_ad_slot2");

  const firstStory = stories[0];

  const textDataRender = (story) => (
    <div styleName="text-wrapper">
      <div>
        <Link href={story.url}>
          <Headline
            headerLevel={2}
            headlineType={35}
            text={story.headline}
            className="story-headline"
            styleName={`${publisherAttributes.lang}-headline-style`}
          />
        </Link>
        <StoryMetaData
          story={story}
          updatedFont={true}
          src="big-video-story-card-2-ad"
          publisherLang={publisherAttributes.lang}
        />
      </div>
      <div styleName="icon-wrapper">
        <SocialShare template={SocialShareTemplate} title={story.headline} fullUrl={encodeURI(story.url)} />
      </div>
    </div>
  );

  return (
    <div styleName="wrapper">
      <div styleName="image-wrapper">
        <Link href={firstStory.url}>
          <CardImage
            story={firstStory}
            aspectRatio={[16, 9]}
            imageType="image16x9"
            widths={[1000]}
            showAlternateImage={true}
          />
        </Link>
        {textDataRender(firstStory)}
      </div>

      <div styleName="content-wrapper">
        <div styleName="side-ad">
          <DfpAd adtype="News_336x280_R1" slotId={adSlotId1} />
        </div>
        {stories.splice(1, 3).map((story, index) => (
          <CustomStoryCard5
            key={index}
            story={story}
            className="related-stories"
            imageType="image4x3"
            aspectRatio={[4, 3]}
            headlineType={16}
            displayStoryIcon={true}
            updateFont={true}
            src="big-video-story-card-2-ad"
            publisherLang={publisherAttributes.lang}
          />
        ))}
      </div>
      <div styleName="horizontal-ad">
        <DfpAd adtype="News_728x90_T1" slotId={adSlotId2} />
      </div>
    </div>
  );
};

BigVideoStoryCard2Ad.propTypes = {
  className: string,
  story: object,
  collection: object,
  publisherAttributes: object,
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
});

export default connect(mapStateToProps, null)(BigVideoStoryCard2Ad);
